import { IIndexable } from 'core-ts-types';
import * as _4 from 'lodash4';
import { HoldsResolutionServant, IHoldsResolution } from './../servants/holds_resolution_servant';

export class ResolutionType implements IIndexable {
  id: number;
  group: string;
  rank: number;
  channel: string;
  contact_label: string;
  contact_value: string;
  contact_display_value: string;
  metadata: IHoldsResolution;

  constructor(resolution: ResolutionType) {
    resolution.metadata = HoldsResolutionServant.build(resolution);
    _4.merge(this, resolution);
  }

  static build(resolution: ResolutionType): ResolutionType {
    return new ResolutionType(resolution);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-holds/src/builders/resolution_types_builder.ts